import React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

import ClearFiltersButton from "./ClearFiltersButton";
import MuiFacetView from "./facets/MuiFacetView";
import { TOOLBAR_STRIP_HEIGHT } from "../styles/layoutSizes";

// SearchUI components
import { Facet } from "@elastic/react-search-ui";

const ResetWrap = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  paddingInline: theme.spacing(1.25),
  paddingBlock: 0,
  height: TOOLBAR_STRIP_HEIGHT,
  flexShrink: 0,
  backgroundColor: theme.palette.background.paper,
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const FacetsScroll = styled("div")({
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
  WebkitOverflowScrolling: "touch",
  "& > :last-child": {
    borderBottom: "none",
  },
});

const Copyright = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: 40,
  flexShrink: 0,
  backgroundColor: theme.palette.background.paper,
  borderTop: `1px solid ${theme.palette.divider}`,
}));

function SearchSideContent() {
  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <ResetWrap>
        <ClearFiltersButton
          render={({ count, onClick }) => (
            <Button
              size="small"
              variant="text"
              color="primary"
              startIcon={<RestartAltIcon fontSize="small" />}
              onClick={onClick}
              sx={{ textTransform: "none", fontWeight: 500 }}
            >
              Reset filters{count ? ` (${count})` : ""}
            </Button>
          )}
        />
      </ResetWrap>
      <FacetsScroll>
      <Facet field="new_addition" label="New Addition" filterType="any" isFilterable={false} view={MuiFacetView} />
      <Facet field="legal_classification" label="Legal Classification" filterType="any" isFilterable={false} view={MuiFacetView} />
      <Facet field="type" label="Type" filterType="any" isFilterable={false} view={MuiFacetView} />
      <Facet field="action" label="Action" filterType="any" isFilterable={false} view={MuiFacetView} />
      <Facet field="make" label="Make" filterType="any" isFilterable={true} view={MuiFacetView} />
      <Facet field="calibres" label="Calibres" filterType="any" isFilterable={true} view={MuiFacetView} />
      <Facet field="barrel_lengths" label="Barrel Length (mm)" filterType="any" isFilterable={false} view={MuiFacetView} />
      <Facet field="country_of_manufacturer" label="Country of Manufacturer" filterType="any" isFilterable={true} view={MuiFacetView} />
      <Facet field="banned_oic1" label="Affected by May 2020 OIC" filterType="any" isFilterable={false} view={MuiFacetView} />
      <Facet field="banned_oic2" label="Affected by Dec 2024 OIC" filterType="any" isFilterable={false} view={MuiFacetView} />
      <Facet field="banned_oic3" label="Affected by Mar 2025 OIC" filterType="any" isFilterable={false} view={MuiFacetView} />
      <Facet field="oic_legal_authorities" label="OIC Category" filterType="any" isFilterable={false} view={MuiFacetView} />
      <Facet field="reclassified_date" label="Date Added/Reclassified (OIC Firearms)" filterType="any" isFilterable={true} view={MuiFacetView} />
      </FacetsScroll>
      <Copyright>
        <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.7rem" }}>
          © {new Date().getFullYear()} Armalytics, Inc.
        </Typography>
      </Copyright>
    </Box>
  );
}

export default SearchSideContent;
